import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasScrollComponent } from './gas-scroll.component';
import { GasScrollbarComponent } from './gas-scrollbar/gas-scrollbar.component';

@NgModule({
  declarations: [
    GasScrollComponent,
    GasScrollbarComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    GasScrollComponent,
  ],
})
export class GasScrollModule { }
